import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

const lightbox = new PhotoSwipeLightbox({
    gallery: '.single-showroom-slider .swiper-wrapper',
    bgOpacity: 0.6,
    children: 'a',
    mainClass: 'pswp-showrooms-custom-bg',
    showHideAnimationType: 'fade',
    zoomAnimationDuration: false,
    showAnimationDuration: 250,
    hideAnimationDuration: 250,
    pswpModule: () => import('photoswipe')
});

const gallery = new PhotoSwipeLightbox({
    gallery: '.gallery-wrap',
    bgOpacity: 0.6,
    children: 'a',
    // mainClass: 'pswp-showrooms-custom-bg',
    showHideAnimationType: 'fade',
    zoomAnimationDuration: false,
    showAnimationDuration: 250,
    hideAnimationDuration: 250,
    pswpModule: () => import('photoswipe')
});

const realisation = new PhotoSwipeLightbox({
    gallery: '.realisations-galery',
    bgOpacity: 0.6,
    children: 'a',
    // mainClass: 'pswp-showrooms-custom-bg',
    showHideAnimationType: 'fade',
    zoomAnimationDuration: false,
    showAnimationDuration: 250,
    hideAnimationDuration: 250,
    pswpModule: () => import('photoswipe')
});

// Fix pour utilisation de thumbnail n'ayant pas les mêmes ratio que les grandes images
lightbox.addFilter('useContentPlaceholder', (useContentPlaceholder, content) => { return false; });
gallery.addFilter('useContentPlaceholder', (useContentPlaceholder, content) => { return false; });
realisation.addFilter('useContentPlaceholder', (useContentPlaceholder, content) => { return false; });

lightbox.init();
gallery.init();
realisation.init();